/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssociatedResultTemplate,
    AssociatedResultTemplateFromJSON,
    AssociatedResultTemplateFromJSONTyped,
    AssociatedResultTemplateToJSON,
} from './AssociatedResultTemplate';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';

/**
 * 
 * @export
 * @interface CompetenceTemplate
 */
export interface CompetenceTemplate {
    /**
     * 
     * @type {string}
     * @memberof CompetenceTemplate
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetenceTemplate
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompetenceTemplate
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompetenceTemplate
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof CompetenceTemplate
     */
    type?: LearningCompetenceTypeEnum;
    /**
     * 
     * @type {Array<AssociatedResultTemplate>}
     * @memberof CompetenceTemplate
     */
    associatedResultTemplates?: Array<AssociatedResultTemplate> | null;
}

export function CompetenceTemplateFromJSON(json: any): CompetenceTemplate {
    return CompetenceTemplateFromJSONTyped(json, false);
}

export function CompetenceTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetenceTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
        'associatedResultTemplates': !exists(json, 'associatedResultTemplates') ? undefined : (json['associatedResultTemplates'] === null ? null : (json['associatedResultTemplates'] as Array<any>).map(AssociatedResultTemplateFromJSON)),
    };
}

export function CompetenceTemplateToJSON(value?: CompetenceTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
        'associatedResultTemplates': value.associatedResultTemplates === undefined ? undefined : (value.associatedResultTemplates === null ? null : (value.associatedResultTemplates as Array<any>).map(AssociatedResultTemplateToJSON)),
    };
}

